<div
  id="user-create"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      {{ 'USERS.CREATEUSER.TITLE' | translate }}
    </div>
  </div>

  <!-- / HEADER -->

  <div class="content-card" fxFill>
    @if (isLoading) {
      <mat-progress-bar
        color="accent"
        mode="indeterminate"
        class="mat-progress-bar">
      </mat-progress-bar>
    }

    @if (!isLoading && !isErrorGetUsersDemands) {
      <div class="content">
        <div class="row general-content">
          <div fxFlex="70" class="user-interface">
            <div class="row">
              <div fxLayoutAlign="end end">
                <button
                  mat-button
                  color="accent"
                  class="add-button"
                  (click)="openAddUserdialog()">
                  {{ 'USERS.CREATEUSER.ADDBTN' | translate }}
                </button>
              </div>
              @if (hasNoDemands) {
                <div
                  id="error-noservice"
                  fxLayout="column"
                  fxLayoutAlign="center center">
                  <div
                    class="content"
                    fxLayout="column"
                    fxLayoutAlign="center center">
                    <div class="error-code">
                      {{ 'USERS.CREATEUSER.NODEMANDS' | translate }}
                    </div>
                  </div>
                </div>
              } @else {
                <div fxLayoutGap="15px">
                  <table
                    id="gridContainer"
                    mat-table
                    [dataSource]="dataSource"
                    matSort
                    (matSortChange)="sortData($event)"
                    multiTemplateDataRows>
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'TABLE.CREATEUSER.HEADER.STATUS' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        @if (element.status === 'En attente') {
                          <div class="current-value waiting-tag">
                            {{ 'GENERAL.WAITING' | translate }}
                          </div>
                        }
                        @if (element.status === 'Terminé') {
                          <div class="current-value success-tag">
                            {{ 'TABLE.CREATEUSER.STATUS.FINISHED' | translate }}
                          </div>
                        }
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="firstname">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header="firstname"
                        class="sortable">
                        {{ 'USERS.SINGLE.INFO.FIRSTNAME' | translate }}
                        <mat-icon
                          [style.color]="
                            sortedValue !== 'firstName'
                              ? '#757575'
                              : 'transparent'
                          "
                          class="sort-icon"
                          >sort</mat-icon
                        >
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.firstname }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="lastname">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header="lastname"
                        class="sortable">
                        {{ 'USERS.SINGLE.INFO.LASTNAME' | translate }}
                        <mat-icon
                          [style.color]="
                            sortedValue !== 'lastName'
                              ? '#757575'
                              : 'transparent'
                          "
                          class="sort-icon"
                          >sort</mat-icon
                        >
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.lastname }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="gender">
                      <th
                        mat-header-cell
                        *matHeaderCellDef
                        mat-sort-header="gender"
                        class="sortable">
                        {{ 'USERS.SINGLE.INFO.GENDER' | translate }}
                        <mat-icon
                          [style.color]="
                            sortedValue !== 'gender' ? '#757575' : 'transparent'
                          "
                          class="sort-icon"
                          >sort</mat-icon
                        >
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.gender }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="phone">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'USERS.SINGLE.INFO.PHONE' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.mobilephone }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'USERS.SINGLE.INFO.ADDRESS' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.address }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="npa">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'USERS.SINGLE.INFO.NPA' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.npa }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="locality">
                      <th mat-header-cell *matHeaderCellDef>
                        {{ 'USERS.SINGLE.INFO.LOCALITY' | translate }}
                      </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.locality }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="expand">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-icon-button (click)="toggleRow(element)">
                          <mat-icon>more_horiz</mat-icon>
                        </button>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="expandedDetail">
                      <td
                        mat-cell
                        *matCellDef="let element"
                        [attr.colspan]="displayedColumns.length">
                        @if (expandedElement === element) {
                          <div class="expanded-detail">
                            @if (windowWidth < 1500) {
                              <p>
                                <strong>
                                  {{ 'USERS.SINGLE.INFO.PHONE' | translate }}:
                                </strong>
                                {{ element.mobilephone }}
                              </p>
                            }
                            @if (windowWidth < 1300) {
                              <p>
                                <strong>
                                  {{ 'USERS.SINGLE.INFO.ADDRESS' | translate }}:
                                </strong>
                                {{ element.address }}
                              </p>
                            }
                            @if (windowWidth < 1100) {
                              <p>
                                <strong>
                                  {{ 'USERS.SINGLE.INFO.NPA' | translate }}:
                                </strong>
                                {{ element.npa }}
                              </p>
                            }
                            @if (windowWidth < 900) {
                              <p>
                                <strong>
                                  {{
                                    'USERS.SINGLE.INFO.LOCALITY' | translate
                                  }}:
                                </strong>
                                {{ element.locality }}
                              </p>
                            }
                            @if (windowWidth < 500) {
                              <p>
                                <strong>
                                  {{ 'USERS.SINGLE.INFO.GENDER' | translate }}:
                                </strong>
                                {{ element.gender }}
                              </p>
                            }
                            <p>
                              <strong>
                                {{ 'USERS.SINGLE.INFO.AVS' | translate }}:
                              </strong>
                              {{ element.avs }}
                            </p>
                            <p>
                              <strong>
                                {{
                                  'USERS.SINGLE.INFO.DATEOFBIRTH' | translate
                                }}:
                              </strong>
                              {{ element.birthday }}
                            </p>
                            <p>
                              <strong>
                                {{
                                  'TABLE.CREATEUSER.HEADER.GRPETABLISSEMENT'
                                    | translate
                                }}:
                              </strong>
                              {{ element.settlementGroup }}
                            </p>
                            <p>
                              <strong>
                                {{
                                  'USERS.SINGLE.INFO.PREFERREDLANGUAGE'
                                    | translate
                                }}:
                              </strong>
                              {{ element.language }}
                            </p>
                            <p>
                              <strong>
                                {{ 'USERS.SINGLE.INFO.EMAIL' | translate }}:
                              </strong>
                              {{ element.recoveryEmail }}
                            </p>
                            <p>
                              <strong>
                                {{ 'USERS.SINGLE.INFO.ROLES' | translate }}:
                              </strong>
                              {{ element.roles }}
                            </p>
                          </div>
                        }
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                      mat-row
                      *matRowDef="
                        let row;
                        let index = dataIndex;
                        columns: displayedColumns
                      "
                      class="element-row"
                      [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                    <tr
                      mat-row
                      *matRowDef="
                        let row;
                        let index = dataIndex;
                        columns: ['expandedDetail']
                      "
                      class="detail-row"
                      [ngClass]="{ alternate: index % 2 === 0 }"></tr>
                  </table>
                  <mat-paginator
                    [hidePageSize]="true"
                    [pageSize]="5"
                    showFirstLastButtons>
                  </mat-paginator>
                </div>
              }
            </div>
          </div>
          <div fxFlex="30" class="info-interface">
            <mat-card class="description-card">
              <h2>{{ 'USERS.CREATEUSER.DESCRIPTION.TITLE' | translate }}</h2>
              <div class="message-box warning">
                {{ 'USERS.CREATEUSER.DESCRIPTION.LINE1' | translate }}
                <ul>
                  <li>
                    {{ 'USERS.CREATEUSER.DESCRIPTION.POINT1' | translate }}
                  </li>
                  <li>
                    {{ 'USERS.CREATEUSER.DESCRIPTION.POINT2' | translate }}
                  </li>
                  <li>
                    {{ 'USERS.CREATEUSER.DESCRIPTION.POINT3' | translate }}
                  </li>
                </ul>
                {{ 'USERS.CREATEUSER.DESCRIPTION.LINE2' | translate }}
              </div>
              <div class="message-box error">
                {{ 'USERS.CREATEUSER.DESCRIPTION-2.LINE1' | translate }}
                <ul>
                  <li>
                    {{ 'USERS.CREATEUSER.DESCRIPTION-2.POINT1' | translate }}
                  </li>
                  <li>
                    {{ 'USERS.CREATEUSER.DESCRIPTION-2.POINT2' | translate }}
                  </li>
                  <li>
                    {{ 'USERS.CREATEUSER.DESCRIPTION-2.POINT3' | translate }}
                  </li>
                  <li>
                    {{ 'USERS.CREATEUSER.DESCRIPTION-2.POINT4' | translate }}
                  </li>
                </ul>
                {{ 'USERS.CREATEUSER.DESCRIPTION.LINE2' | translate }}
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    }
    @if (isErrorGetUsersDemands) {
      <div>
        <div class="message-box error user-created">
          <app-error-message [error]="errorGetUsersDemands.error" />
        </div>
      </div>
    }
  </div>
</div>
